import type { MessagingCreateChatRoom201LastMessageBasicInfo } from './messagingCreateChatRoom201LastMessageBasicInfo';
import type { MessagingCreateChatRoom201LastMessageSender } from './messagingCreateChatRoom201LastMessageSender';
import type { MessagingCreateChatRoom201LastMessageStatus } from './messagingCreateChatRoom201LastMessageStatus';

/**
 * 마지막 메시지
 */
export type MessagingCreateChatRoom201LastMessage = {
  basicInfo?: MessagingCreateChatRoom201LastMessageBasicInfo;
  /** 발신자 정보 */
  sender?: MessagingCreateChatRoom201LastMessageSender;
  /** 메시지 상태 정보 */
  status?: MessagingCreateChatRoom201LastMessageStatus;
};
